/**
 * Helper module to calculate correct prices.
 */

var TOTAL_PRICE_PERCENT_RULE = 1;

function _roundDollarAmount(amount) {
  amount = amount.toFixed(3); // Float issues
  var multiple =  Math.pow(10, 2);
  var product = (amount * multiple).toFixed(3);
  return Math.round(product) / multiple;
}

function _ceilDollarAmount(amount) {
  amount = amount.toFixed(3); // Float issues
  var multiple =  Math.pow(10, 2);
  var product = (amount * multiple).toFixed(3);
  return Math.ceil(product) / multiple;
}

/**
 *
 * @param basePrice
 * @param totalPrice
 * @param totalPercent
 * @returns {{royalty: number, markup: number, totalPrice: *, valid: boolean, message: *}}
 * @private
 */
function _totalPriceRoyaltyCalc(basePrice, totalPrice, totalPercent) {
  var royalty = 0;
  var markup = totalPrice - basePrice;
  var message = null;
  var valid = false;
  var adjustedMarkup = markup;
  var adjustedTotalPrice = totalPrice;

  if (totalPercent) {
    var minTotalPrice = _ceilDollarAmount(basePrice/(1 - totalPercent));

    if (minTotalPrice > totalPrice) {
      message = "Your total price must be large enough to cover the royalty. Prices that do not meet the minimum total price have been updated.";
      adjustedTotalPrice = minTotalPrice;
      royalty = _ceilDollarAmount(adjustedTotalPrice * totalPercent);
      adjustedMarkup = minTotalPrice - basePrice - royalty;
    } else {
      royalty = _ceilDollarAmount(totalPrice * totalPercent);
      adjustedMarkup = totalPrice - basePrice - royalty;
      valid = true;
    }

  } else {
    throw Error("Total percent not found for pricing rule.");
  }

  return {
    royalty: royalty,
    markup: _roundDollarAmount(adjustedMarkup),
    totalPrice: adjustedTotalPrice,
    valid: valid,
    message: message
  };
}

/**
 *
 * @param basePrice
 * @param totalPrice
 * @returns {{royalty: number, markup: number, totalPrice: *, valid: boolean, message: *}}
 * @private
 */
function _defaultTotalPriceCalc(basePrice, totalPrice) {
  var markup = totalPrice - basePrice;
  var message = null;
  var valid = true;

  if (totalPrice < basePrice) {
    totalPrice = basePrice;
    markup = 0;
    valid = false;
  }

  return {
    royalty: 0,
    markup: _roundDollarAmount(markup),
    totalPrice: _ceilDollarAmount(totalPrice),
    valid: valid,
    message: message
  };
}

module.exports = {

  /**
   * Gets the price given a base price, total price, and optional pricing rule
   *
   * @param basePrice int
   * @param totalPrice int
   * @param pricingRule object
   * @returns {{}}
   */
  getPricing: function getRoyaltyByPricingRuleId(basePrice, totalPrice, pricingRule) {
    var pricingInfo = {};
    basePrice = parseFloat(basePrice);
    totalPrice = parseFloat(totalPrice);

    switch(parseInt(pricingRule.id, 10)) {
      case TOTAL_PRICE_PERCENT_RULE:
        var totalPercent = parseFloat(pricingRule.totalPercent);
        pricingInfo = _totalPriceRoyaltyCalc(basePrice, totalPrice, totalPercent);
        break;
      default:
        pricingInfo = _defaultTotalPriceCalc(basePrice, totalPrice);
    }

    return pricingInfo;
  }

};
